import React from "react"
import { motion } from "framer-motion"
export default function PricingPage() {
    return(
        <div className="bg-gray-50 min-h-screen font-sans pt-10">
            <motion.section
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                className="p-6 md:p-16 text-center"
            >
                <h2 className="text-4xl md:text-5xl font-bold mb-4 text-gray-800">
                Simple, Transparent Pricing
                </h2>
                <p className="text-gray-600 text-base md:text-lg max-w-3xl mx-auto">
                Choose a plan that fits your growth stage. Start for free. Upgrade anytime.
                </p>
            </motion.section>

            <motion.section
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay:0.2, duration:0.8  }}
                viewport={{ once: true }}
                className="py-12 px-4 md:px-16"
            >
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {[
                    {
                    title: "Starter",
                    price: "₹0/mo",
                    desc: "Perfect for testing the waters.",
                    features: ["1 ad account", "Weekly insights", "Basic suggestions"],
                    cta: "Get Started"
                    },
                    {
                    title: "Pro",
                    price: "₹1999/mo",
                    desc: "For growing businesses that want AI to do the heavy lifting.",
                    features: ["5 ad accounts", "Daily insights", "Smart AI suggestions", "Creative Analyzer"],
                    cta: "Start Trial"
                    },
                    {
                    title: "Agency",
                    price: "Custom",
                    desc: "Ideal for agencies or teams managing 10+ brands.",
                    features: ["20+ accounts", "White-label dashboard", "Priority support", "Dedicated manager"],
                    cta: "Contact Sales"
                    }
                ].map((plan, i) => (
                    <motion.div
                        key={i}
                        initial={{ y: 0 }}
                        transition={{ duration:0.1  }}
                        whileHover={{ y: -8, animation:"ease-in-out"  }}
                        className="p-8 bg-white border rounded-xl shadow hover:shadow-xl transition flex flex-col justify-between"
                    >
                    <div>
                        <h3 className="text-2xl font-bold text-gray-800 mb-1">{plan.title}</h3>
                        <p className="text-sm text-gray-500 mb-4">{plan.desc}</p>
                        <p className="text-3xl font-bold text-blue-600 mb-6">{plan.price}</p>
                        <ul className="text-gray-600 text-left space-y-2 mb-6">
                        {plan.features.map((f, idx) => (
                            <li key={idx}>✅ {f}</li>
                        ))}
                        </ul>
                    </div>
                    <button className="bg-blue-600 text-white py-2 px-4 rounded-full font-semibold hover:bg-blue-700 transition">
                        {plan.cta}
                    </button>
                    </motion.div>
                ))}
                </div>
            </motion.section>

            <motion.section
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{ delay: 0.3 }}
                className="py-20 px-4 md:px-12"
            >
                <h3 className="text-3xl md:text-4xl font-bold text-center mb-6 text-gray-800">
                Start Free — Upgrade When You’re Ready
                </h3>
                <p className="text-center text-gray-600 max-w-2xl mx-auto">
                No setup fees. No hidden costs. Try every feature risk-free and unlock the full power of AdMentorAI when it makes sense for your business.
                </p>
            </motion.section>
        </div>
    )
}